var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3369_8609)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0144 22.9336H0V0H24.0144V22.9336Z",
    fill: "#EA4C3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2975 3.50077C12.6591 3.67117 12.5839 3.89197 12.4727 4.93517C12.3591 6.01117 11.9783 7.97677 11.2447 9.91037C10.5103 11.8408 9.42068 13.7376 8.47108 15.1416C7.52228 16.5464 6.71028 17.4592 6.09108 17.9864C5.46948 18.5136 5.03988 18.6544 4.75908 18.7008C4.48068 18.7472 4.35428 18.7008 4.27908 18.5592C4.20388 18.4184 4.17748 18.1864 4.24228 17.9032C4.30548 17.6232 4.45668 17.2952 4.88548 16.8752C5.31828 16.4536 6.02628 15.9376 7.01428 15.4584C8.00228 14.9784 9.26788 14.5336 10.3071 14.2288C11.3463 13.9256 12.1559 13.7608 12.8647 13.632C13.5751 13.5024 14.1823 13.4104 14.7775 13.3624C15.3727 13.3176 15.9567 13.3176 16.5263 13.3624C17.0959 13.4104 17.6527 13.5024 18.1351 13.6208C18.6151 13.7376 19.0215 13.8776 19.3759 14.1016C19.7295 14.3224 20.0343 14.6272 20.1855 14.968C20.3391 15.3064 20.3391 15.6824 20.2119 15.9504C20.0855 16.22 19.8311 16.3832 19.5407 16.4784C19.2495 16.5704 18.9207 16.5936 18.5271 16.4784C18.1351 16.36 17.6775 16.1024 17.1975 15.7632C16.7167 15.4232 16.2095 15.0016 15.5519 14.3464C14.8927 13.6912 14.0815 12.8024 13.3983 11.936C12.7151 11.0696 12.1559 10.2272 11.7759 9.51277C11.3975 8.79837 11.1943 8.21357 11.0295 7.62877C10.8647 7.04237 10.7383 6.45757 10.6879 5.93117C10.6375 5.40477 10.6607 4.93517 10.7119 4.55997C10.7623 4.18717 10.8399 3.90397 10.9655 3.71597C11.0919 3.53197 11.2703 3.43597 11.3967 3.38957C11.5231 3.34317 11.5999 3.34317 11.6751 3.33117C11.7503 3.31917 11.8255 3.29597 11.9415 3.33117C12.0519 3.36477 12.1983 3.45437 12.3447 3.54557",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3369_8609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.e7134f30f05ed6e88598e17c09e23029.svg";
export { ForwardRef as ReactComponent };